import { FC } from 'react';
import styled from 'styled-components';
import Loader from 'components/Loader';

const TableLoader: FC = () => {
  return (
    <Wrapper>
      <Loader />
    </Wrapper>
  );
};

export default TableLoader;

const Wrapper = styled.div`
  padding: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
